import SocialLogos from './social-logos';
export default SocialLogos;
